export default __webpack_public_path__ + "static/media/what-techniques-for-web.f19c71fb.png";